import $ from "jquery";
import WPAPI from "wpapi";

const apiUrl = $("body").attr("data-rest-url");
const restNamespace = "theme/v1";

const wp = new WPAPI({ endpoint: apiUrl });
wp.blogQuery = wp.registerRoute(restNamespace, "blog-query");
wp.publicationsQuery = wp.registerRoute(restNamespace, "publications-query");

export default wp;
